import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { KwikUILoaderComponent } from "./loader.component";
import { KwikUILoaderService } from "./loader.service";

@NgModule({
  declarations: [KwikUILoaderComponent],
  imports: [CommonModule],
  exports: [KwikUILoaderComponent],
  providers: [KwikUILoaderService]
})
export class KwikUILoaderModule {}
